import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
import {
    calendarsForCalendarProviderLoaded,
    calendarProviderAccountRemoved,
} from '../actions/publicActions';
import { localLieUpdateToCalendarSubscriptions } from '../actions/internalActions';
import { CalendarProviderType } from '../store/schema/CalendarProviderType';
import type { TeamSnapCalendar } from '../store/schema/TeamSnapCalendar';
import type { SubscribeCalendarRequest } from '../types/SubscribeCalendarRequest';
import type { TeamSnapSubscribeCalendarRequest } from '../types/TeamSnapSubscribeCalendarRequest';

mutator(calendarsForCalendarProviderLoaded, actionMessage => {
    const store = getStore();
    const { providerId, calendars } = actionMessage;

    store.providerAccountCalendars.set(providerId, calendars);
});

mutator(calendarProviderAccountRemoved, actionMessage => {
    const store = getStore();
    const { calendarProviderAccountId } = actionMessage;

    store.providerAccountCalendars.delete(calendarProviderAccountId);
});

mutator(localLieUpdateToCalendarSubscriptions, actionMessage => {
    const store = getStore();

    const { providerId, unsubscribeCalendarIds, subscribeRequests } = actionMessage;

    // Mark the unsubscribe calendars
    store.providerAccountCalendars
        .get(providerId)
        .filter(cal => unsubscribeCalendarIds.some(id => id === cal.id))
        .forEach(cal => {
            cal.isSubscribed = false;

            if (cal.providerType === CalendarProviderType.TeamSnap) {
                (cal as TeamSnapCalendar).calendarTypeSubscribed = null;
            }
        });

    // Mark the subscribed calendars
    const subscribeRequestsMap = subscribeRequests.reduce<{
        [calendarId: string]: SubscribeCalendarRequest;
    }>((agg, req) => {
        agg[req.calendarId] = req;

        return agg;
    }, {});
    store.providerAccountCalendars
        .get(providerId)
        .filter(cal => !!subscribeRequestsMap[cal.id])
        .forEach(cal => {
            cal.isSubscribed = true;

            if (cal.providerType === CalendarProviderType.TeamSnap) {
                (cal as TeamSnapCalendar).calendarTypeSubscribed = (subscribeRequestsMap[
                    cal.id
                ] as TeamSnapSubscribeCalendarRequest).calendarType;
            }
        });
});
